module.exports = __webpack_public_path__ + "static/logo-light-ff269288cd55f11bf6aac1fa65be8730.png";